import React, { useEffect, useState } from "react";
import { DashboardLayout } from "@/components/Layout/DashboardLayout";
import api from "@/lib/api";
import { adminNavItems } from "./_nav";
import { useLang } from "@/contexts/LanguageContext";

export default function AdminSubscriptions() {
  const { t } = useLang();
  const [plans, setPlans] = useState([]);
  useEffect(() => { api.get("/subscription-plans").then(r => setPlans(r.data)); }, []);

  return (
    <DashboardLayout items={adminNavItems(t)} title={t("plans")}>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {plans.map(p => (
          <div key={p.key} className={`so-card p-5 ${p.highlighted ? "border-[var(--so-orange)]" : ""}`} data-testid={`a-plan-${p.key}`}>
            <div className="text-xs uppercase tracking-wider font-bold text-[var(--so-text-soft)]">{p.audience}</div>
            <div className="font-bold text-xl mt-1">{p.name}</div>
            <div className="mt-2 flex items-baseline gap-1">
              <span className="text-3xl font-extrabold">${p.price_monthly}</span>
              <span className="text-xs text-[var(--so-text-soft)]">/mo · ${p.price_yearly}/yr</span>
            </div>
            <ul className="mt-3 text-sm space-y-1 text-[var(--so-text-soft)]">
              {p.features.map(f => <li key={f}>• {f}</li>)}
            </ul>
          </div>
        ))}
      </div>
    </DashboardLayout>
  );
}
